import { FinancialDocumentListItem } from "@common/types/financialDocument";
import {
    FinancialDocumentColumn,
    FinancialDocumentSortValue,
} from "@common/types/views/financialDocumentViews";
import { ViewConfig } from "@lib/views";
import { DOCUMENT_CATEGORY_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { UploadDateCell } from "./Cells/UploadDateCell";
import { NameCell } from "./Cells/NameCell";
import { EntityCell } from "./Cells/EntityCell";
import { ActionsCell } from "./Cells/ActionsCell";
import { MatchedTransactionCell } from "./Cells/MatchedTransactionCell";
import { UploaderCell } from "./Cells/UploaderCell";
import { DocumentCategoryCell } from "./Cells/DocumentCategoryCell";
import { CounterpartyCell } from "./Cells/CounterpartyCell";
import { FinancialAccountCell } from "./Cells/FinancialAccountCell";
import { PeriodCell } from "./Cells/PeriodCell";
import { DocumentStatusCell } from "./Cells/DocumentStatusCell";

export const financialDocumentsViewConfig: ViewConfig<
    FinancialDocumentListItem,
    FinancialDocumentColumn,
    FinancialDocumentSortValue
> = {
    columns: {
        [FinancialDocumentColumn.UPLOAD_DATE]: {
            accessorKey: "createdAt",
            name: "Upload date",
            header: "Upload date",
            cell: UploadDateCell,
            sort: {
                asc: FinancialDocumentSortValue.UPLOAD_DATE_ASC,
                desc: FinancialDocumentSortValue.UPLOAD_DATE_DESC,
            },
            minSize: 120,
            maxSize: 140,
        },
        [FinancialDocumentColumn.NAME]: {
            accessorKey: "fileName",
            name: "Name",
            header: "Name",
            cell: NameCell,
            sort: {
                asc: FinancialDocumentSortValue.NAME_ASC,
                desc: FinancialDocumentSortValue.NAME_DESC,
            },
            minSize: 300,
            maxSize: 600,
            immutable: true,
        },
        [FinancialDocumentColumn.ENTITY]: {
            accessorKey: "entity",
            name: "Entity",
            header: "Entity",
            cell: EntityCell,
            minSize: 60,
            maxSize: 60,
        },
        [FinancialDocumentColumn.FINANCIAL_ACCOUNT]: {
            accessorKey: "financialAccount",
            name: "Financial account",
            header: "Account",
            cell: FinancialAccountCell,
            minSize: 140,
            maxSize: 160,
        },
        [FinancialDocumentColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: ActionsCell,
            minSize: 60,
            maxSize: 60,
            immutable: true,
            hiddenFromSettings: true,
        },
        [FinancialDocumentColumn.MATCHED_TRANSACTION]: {
            accessorKey: "matchedTransaction",
            name: "Matched transaction",
            header: "Matched transaction",
            cell: MatchedTransactionCell,
            minSize: 180,
            maxSize: 320,
        },
        [FinancialDocumentColumn.UPLOADER]: {
            accessorKey: "uploader",
            name: "Uploaded by",
            header: "By",
            cell: UploaderCell,
            minSize: 40,
            maxSize: 40,
        },
        [FinancialDocumentColumn.DOCUMENT_CATEGORY]: {
            accessorKey: "taxonomyExtraction",
            name: "Document category",
            header: "Document category",
            cell: DocumentCategoryCell,
            ...DOCUMENT_CATEGORY_COLUMN_SIZE,
        },
        [FinancialDocumentColumn.COUNTERPARTY]: {
            accessorKey: "counterparty",
            name: "Counterparty",
            header: "Counterparty",
            cell: CounterpartyCell,
            minSize: 200,
            maxSize: 300,
        },
        [FinancialDocumentColumn.PERIOD]: {
            accessorKey: "taxonomyExtraction",
            name: "Period",
            header: "Period",
            cell: PeriodCell,
            minSize: 220,
            maxSize: 250,
        },
        [FinancialDocumentColumn.STATUS]: {
            accessorKey: "status",
            name: "Status",
            header: "Status",
            cell: DocumentStatusCell,
            minSize: 80,
            maxSize: 80,
        },
    },
};
